import { GetReceiptRequestETicketListInner, GetReceiptRequestEmdListInner } from 'src/sdk-servicing';
import { ReceiptSearchConditionValue, ReceiptSearchTargetLabel } from './receipt-search';
import {
  ChargeableLounge,
  FirstBaggage,
  MealInformation,
  MyBookingPassengerInfo,
} from './mybooking/mybooking.interface';
import { SeatReservationStatus } from './servicing-seatmap/seat-reservation-status';
import { AlertMessageItem, NotRetryableErrorModel } from '@lib/interfaces';
import { BoardingCertificateSearchCondition } from './boarding-certificate';

export interface ServicingCommonModel {
  /** 遷移元画面識別子 */
  previousPageIdentifier?: PREVIOUS_PAGE_IDENTIFIER;

  /** 出張管理番号リスト */
  businessTripNumbers?: string[];

  /** 領収書検索 */
  searchTarget?: ReceiptSearchTargetLabel;
  searchCondition?: ReceiptSearchConditionValue;
  yearAndMonth?: string;
  day?: string;
  eTicketList?: Array<GetReceiptRequestETicketListInner>;
  emdList?: Array<GetReceiptRequestEmdListInner>;
  orderId?: string;
  receivedFrom?: string;
  travelerId?: string;

  /** S05-P020/P021 搭乗証明書検索条件 */
  boardingCertificateSearchCondition?: BoardingCertificateSearchCondition;
  
  /** EMD検索画面表示フラグ */
  emdSearchDisplayFlag?: boolean;

  // S05-P031
  /** 予約詳細遷移元画面区分 */
  reservationDetailPreviousPage?: ReservationDetailPreviousPage;

  /** pnr */
  getOrder?: Object;

  /** 言語コード */
  lang?: string;

  /** 予約詳細表示タブ */
  tabShow?: string;
  /** OKI追加start */
  /** 登録完了時機能種別 */
  completedFunction?: string;
  /** 初回表示フラグ*/
  isFirstDisplay?: boolean;
  /** 次に行うアクション */
  nextAction?: string;
  /** 規約からの再表示であるか */
  isReload?: boolean;
  /** 初期表示サービス */
  initDisplayService?: string;
  /** 編集中か否か（前画面情報） */
  isEditing?: boolean;
  /** 編集エリア */
  editArea?: string;
  /** 乗客リスト内の乗客のインデックス */
  passengerIndex?: number;
  /** 搭乗者情報リスト */
  lstPassenger?: MyBookingPassengerInfo[];
  chargeableLounge?: ChargeableLounge;
  firstBaggage?: FirstBaggage;
  meal?: MealInformation;
  /**前画面からのエラーメッセージ */
  preErrorMessage?: NotRetryableErrorModel;
  /** 前画面からのワーニングメッセージリスト */
  preWarningMessageList?: Array<AlertMessageItem>;
  /** 代表者メールアドレス */
  representativeMail?: string;
  /** DxAPIリトリーブ要否フラグ */
  dxApiRetrieveFlg?: boolean;
  /** OKI追加end */
  /** KMS追加start */
  /** 登録完了時機能種別 */
  registrationCompleteFunctionType?: string;

  /** バックアップ用言語 */
  backupLanguage?: string;

  /** 座席指定状況 */
  seatReservationStatus?: SeatReservationStatus;

  /** 表示対象セグメントID */
  displayTargetSegmentId?: string;

  /** KMS追加end */
}

/** 予約詳細遷移元画面区分 */
export type ReservationDetailPreviousPage = {
  functionId: string;
  pageId: string;
};

export type PREVIOUS_PAGE_IDENTIFIER = (typeof PREVIOUS_PAGE_IDENTIFIER)[keyof typeof PREVIOUS_PAGE_IDENTIFIER];
export const PREVIOUS_PAGE_IDENTIFIER = {
  /** S01 予約確認 */
  /** ANA Biz 発券申請一覧 */
  ANA_BIZ_APPLICATION_LIST: 'anaBizApplicationList',

  /** S02 サービス申込 */
  /** マイカーバレー申込 */
  MY_CAR_VALET_REQUEST: 'myCarValetRequest',
  /** ペットらくのり申込 */
  PET_EASY_TRAVEL_REQUEST: 'petEasyTravelRequest',
  /** ジュニアパイロット申込 */
  JUNIOR_PILOT_REQUEST: 'juniorPilotRequest',

  /** S03 シートマップ */
  /** シートマップ */
  SEATMAP: 'seatmap',
  /** 座席属性指定 */
  SEAT_ATTRIBUTE_REQUEST: 'seatAttributeRequest',
  /** シートマップ参照 */
  INFORMATIVE_SEATMAP: 'informativeSeatmap',

  /** 予約検索 */
  BOOKING_SEARCH: 'bookingSearch',
  /** 予約一覧 */
  BOOKING_LIST: 'bookingList',
  /** 予約詳細 */
  MYBOOKING: 'mybooking',
  /** 予約詳細(旅程) */
  MYBOOKING_ITINERARY: 'mybookingItinerary',
  /** 予約詳細(搭乗者) */
  MYBOOKING_PASSENGER: 'mybookingPassenger',
  /** 予約詳細(サービス) */
  MYBOOKING_SERVICE: 'mybookingService',
  /** 規約 */
  AGREEMENT: 'agreement',
  /** ラウンジ申込 */
  LOUNGE_SERVICE_REQUEST: 'loungeServiceRequest',
  /** 手荷物申込 */
  BAGGAGE_REQUEST: 'baggageRequest',
  /** 機内食申込 */
  FLIGHT_MEA_REQUEST: 'flightMeaRequest',
  /** Ancillary支払情報入力 */
  SERVICE_PAYMENT_INFORMATION_INPUT: 'servicePaymentInformationInput',
  /** Ancillary購入完了 */
  SERVICE_PAYMENT_COMPLEATED: 'servicePaymentCompleated',
  /** 搭乗者情報入力 */
  PASSENGER_INFORMATION_INPUT: 'passengerInformationInput',
  /** AMCログイン */
  LOGIN: 'login',

  /** S05 ドキュメント表示 */
  /** 領収書検索 */
  RECEIPT_SEARCH: 'receiptSearch',
  /** 領収書選択 */
  RECEIPT_SELECT: 'receiptSelect',
  /** 搭乗証明書検索 */
  BOARDING_CERTIFICATE_SEARCH: 'boardingCertificateSearch',
  /** 搭乗証明書表示 */
  BOARDING_CERTIFICATE_SELECT: 'boardingCertificateSelect',
  /** EMD検索 */
  EMD_SEARCH: 'emdSearch',
  /** eチケット/EMDお客様控え表示 */
  EMD_SELECT: 'emdSelect',
  /** ANA Biz ご利用明細書表示 */
  ANABIZ_USAGE_STATEMENT_SELECT: 'anabizUsageStatementSelect',

  /** S06 リダイレクト案内 */
  /** 免税品プリオーダー案内 */
  DUTY_FREE_PREORDER_GUIDANCE: 'dutyFreePreorderGuidance',
  /** ヤマト手荷物案内 */
  YAMATO_BAGGAGE_GUIDANCE: 'yamatoBaggageGuidance',

  /** S07 予約基本情報 */
  /** 予約基本情報登録 */
  RESERVATION_BASIC_INFORMATION_INPUT: 'reservationBasicInformationInput',
} as const;

/** KMS追加start */
/** 予約詳細表示タブ */
export type MY_BOOKING_TAB_IDENTIFIER = (typeof MY_BOOKING_TAB_IDENTIFIER)[keyof typeof MY_BOOKING_TAB_IDENTIFIER];
export const MY_BOOKING_TAB_IDENTIFIER = {
  SERVICE: 'service',
} as const;
/** KMS追加end */
